import { render, staticRenderFns } from "./RadioboxBlank.vue?vue&type=template&id=50bbd593&"
import script from "./RadioboxBlank.vue?vue&type=script&lang=js&"
export * from "./RadioboxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports